import React from 'react';
import { AutocompleteMulti, BaseTextFieldProps } from '../../Inputs';
import { useAllDiagnosisQuery } from '@uplift/queries';


export const DiagnosisAutocomplete: React.VFC<{
  name: string;
  color?: BaseTextFieldProps['color'];
  label?: React.ReactNode;
  placeholder?: string;
  helperText?: string;
  disabled?: boolean;
}> = (props) => {
  const { data } = useAllDiagnosisQuery();

  return (
    <AutocompleteMulti
      {...props}
      options={data ?? []}
      getOptionLabel={d => `${d?.code} ${d?.name}`}
      extractId
    />
  );
};
